export const carIconWrapperStyles = {
  position: "absolute",
  top: { xs: -32, md: -78, lg: 8 },
  left: 0,
  height: { xs: 30, md: 96 },
  width: "100%",
};

export const lineIconStyles = {
  width: "100%",
  overflow: "hidden",
  position: "absolute",
  top: { xs: -44, md: 64 },
  left: 0,
};

export const carIconStyles = {
  position: "absolute",
  top: { xs: 0, md: 16 },
  left: { xs: "80%", sm: "70%", md: "80%", lg: "40%", xl: "42%" },
};

export const secondaryIconWrapperStyles = {
  position: "relative",
  height: 77,
  width: "100%",
  zIndex: -1,
};

export const secondaryLineIconStyles = {
  width: "100%",
  overflow: "hidden",
  position: "absolute",
  left: 0,
  bottom: 35,
};

export const secondaryCarIconStyles = {
  position: "absolute",
  top: 0,
  left: 40,
  opacity: 0.4,
};
